import { render, staticRenderFns } from "../../assets/views/templates/vendas/vendas.html?vue&type=template&id=dda0415c&"
import script from "./Vendas.vue?vue&type=script&lang=js&"
export * from "./Vendas.vue?vue&type=script&lang=js&"
import style0 from "./Vendas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports